import { call, put, takeLatest } from "redux-saga/effects";
import {
  fetchTargetedReconciliationRecords,
  fetchTargetedReconciliationSuccess,
  fetchTargetedReconciliationFailure,
} from "@/store/slices/targetedReconciliation.slice";
import { fetchAllTargetedReconciliation } from "@/services/targetedReconciliation";

function* handleFetchTargetedReconciliation(action: any): any {
  try {
    const response = yield call(fetchAllTargetedReconciliation, action.payload);
    yield put(
      fetchTargetedReconciliationSuccess(response.data)
    );
  } catch (error: any) {
    yield put(fetchTargetedReconciliationFailure(
      error?.response?.data?.message || error?.message || "Failed to fetch targeted reconciliation records"
    ));
  }
}

export default function* targetedReconciliationSaga() {
  yield takeLatest(
    fetchTargetedReconciliationRecords.type,
    handleFetchTargetedReconciliation
  );
}
